import { useEffect, useState } from "react";
import api from "@/lib/api";

export const PERIOD_LABEL = { monthly: "Mensual", annual: "Anual" };
export const PERIOD_SUFFIX = { monthly: "/ mes", annual: "/ año" };
export const PLAN_ORDER = ["basico", "pro", "premium"];
export const PRODUCT_IDS = ["profesionalpos", "profesionalpos_restaurante"];

export function planMeta(catalog, productId, planId) {
  const idx = PLAN_ORDER.indexOf(planId);
  const plans = catalog.products[productId].plans;
  return {
    badge: plans[planId].badge,
    intro: idx > 0 ? `Todo lo del Plan ${plans[PLAN_ORDER[idx - 1]].name} +` : null,
    features: (catalog.plan_features?.[productId] || []).filter((f) => f.from_plan === planId).map((f) => f.text),
  };
}

export function usersText(users) {
  if (users === "unlimited") return "Usuarios ilimitados";
  if (users == null) return "Multiempresa";
  return `${users} usuarios`;
}

export function calcPrice(catalog, cfg, discountPct = 0) {
  if (!catalog) return null;
  const prod = catalog.products[cfg.product];
  const plan = prod.plans[cfg.plan];
  const extraUsers = prod.allows_extra_users ? Number(cfg.extra_users || 0) : 0;
  const extraTerminals = Number(cfg.extra_terminals || 0);
  const base = plan[cfg.period];
  const terminalsCost = catalog.addons.terminal[cfg.period] * extraTerminals;
  const usersCost = catalog.addons.user[cfg.period] * extraUsers;
  const subtotal = base + terminalsCost + usersCost;
  const discount = Math.round(subtotal * discountPct) / 100;
  return { base, terminalsCost, usersCost, subtotal, discount, total: subtotal - discount, extraUsers, extraTerminals };
}

export function useCatalog() {
  const [catalog, setCatalog] = useState(null);
  useEffect(() => {
    api.get("/catalog").then(({ data }) => setCatalog(data)).catch(() => setCatalog(null));
  }, []);
  return catalog;
}
